module.exports = __webpack_public_path__ + "slide-04.png?19c4a3639fb42eabbb3a91bfd1b1501c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide-04.png
// module id = 402
// module chunks = 0